import React, { useEffect, useState } from 'react';
import { Container, Row, Col, InputGroup, Button, FormControl, Spinner, Alert } from 'react-bootstrap';
import { setChatNotification, setUpdateChatMessages } from '../../redux/modules/chat';
import { connect } from 'react-redux';
import { apiUrl, businessName } from '../../utils/consts';
import AppSpinner from '../Extras/AppSpinner/AppSpinner';
import defLogo from '../../img/user.png';
import ChatCard from './ChatCard';
import moment from 'moment';
import 'moment/locale/es';
import './styles/chat.scss';

moment.locale('es');

function mapDispatchToProps(dispatch) {
  return {
    setUpdateChatMessages: update => dispatch(setUpdateChatMessages(update)),
    setChatNotification: show => dispatch(setChatNotification(show))
  };
}

const select = state => {
  return {
    user: state.auth.user,
    token: state.auth.token,
    userId: state.auth.userId,
    updateChatMessages: state.chat.updateChatMessages
  };
};

function ConnectedChat(props) {

  const { userId, token } = props;
  const [loading, setLoading] = useState(true);
  const [loadingChatList, setLoadingChatList] = useState(true);
  const [loadingChatMessages, setLoadingChatMessages] = useState(true);
  const [receiverId, setReceiverId] = useState();
  const [chat, setChat] = useState();
  const [chatList, setChatList] = useState([]);
  const [messages, setMessages] = useState([]);
  const [currentMessage, setCurrentMessage] = useState('');

  useEffect(() => {
    props.setChatNotification({ showNotifications: false });
    if (userId) init();
  }, []);

  useEffect(() => {
    if (props.updateChatMessages) {
      props.setUpdateChatMessages({ updateChatMessages: false });
      if (chat) getChatMessages(chat._id);
      updateChatLists();
    }
  }, [props.updateChatMessages]);

  useEffect(() => {
    if (chat) getChatMessages(chat._id);
  }, [chat]);

  const updateChatLists = async () => {

    const dataChatList = await fetch(`${apiUrl}/chat/lists/${userId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        token,
        businessName
      })
    });

    const res = await dataChatList.json();

    setChatList(res);
  };

  const init = async () => {

    const chatList = await getChatLists();
    const params = new URLSearchParams(window.location.search);
    let receiver;

    if (params.get('id')) receiver = params.get('id');

    if (receiver && chatList.length > 0) {
      
      const currentChat = chatList.find(chat => chat._id === receiver);

      if (currentChat) {

        setChat(currentChat);
        setReceiverId(receiver);
        setLoadingChatMessages(true);
        setLoading(false);

        fetch(`${apiUrl}/chat/update/read`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            userId,
            token,
            businessName,
            chatId: currentChat._id,
          })
        });
        
      } else {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }

  };

  const handleMessageChange = e => {
    setCurrentMessage(e.target.value);
  };

  const getChatLists = async () => {

    if (!loadingChatList) setLoadingChatList(true);

    const dataChatList = await fetch(`${apiUrl}/chat/lists/${userId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        token,
        businessName
      })
    });

    const res = await dataChatList.json();

    setChatList(res);
    setLoadingChatList(false);

    return res;
  };

  const getChatSession = async receiver => {

    if (chatList.length < 1) return;

    const currentChat = chatList.find(chat => chat.users.includes(receiver.toString()));

    if (currentChat) {
      setChat(currentChat);
      setReceiverId(receiver);
      setLoadingChatMessages(true);
    }

    const prom = await fetch(`${apiUrl}/chat/update/read`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        token,
        businessName,
        chatId: currentChat._id
      })
    });

    await prom.json();

    updateChatLists();
  };

  const getChatMessages = async chatId => {
    if (!chat) return;

    const dataChat = await fetch(`${apiUrl}/chatMessage/chat/${chatId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        token,
        businessName
      })
    });

    const res = await dataChat.json();

    setMessages(res);
    setLoadingChatMessages(false);

    updateScroll();
  };

  const handleSendMessage = async () => {
    if (!userId) return false;
    if (!receiverId) return;

    const message = currentMessage;

    setCurrentMessage('');

    if (chat) await sendMessage(message);
    else await createChat(message);
  };

  const createChat = async firstMessage => {

    const prom = await fetch(`${apiUrl}/chat/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        token,
        businessName,
        users: [userId, receiverId]
      })
    });

    const json = await prom.json();

    if (json.success) {
      await getChatLists();
      getChatSession(receiverId);
      await sendMessage(firstMessage);
    }
  };

  const sendMessage = async message => {

    const { user } = props;

    await fetch(`${apiUrl}/chatMessage/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        token,
        businessName,
        chatId: chat._id,
        userName: user.name || `${user.firstName} ${user.lastName}`,
        userImg: user.logo,
        message
      })
    });

    if (chat) getChatMessages(chat._id);
  };

  const updateScroll = () => {
    const element = document.getElementById('messagesList');
    if (element) element.scrollTop = element.scrollHeight;
  };

  const params = new URLSearchParams(window.location.search);

  if (loading) return (<div style={{ margin: '200px 0' }}><AppSpinner /></div>);

  return (
    <Container style={{ paddingTop: '5%', marginBottom: '50px' }}>
      <Row className="chatContainer">
        <Col xs={3} className="chatListContainer" style={{ height: '100%' }}>
          <div style={{ fontSize: '1.3em', fontWeight: 'bold', marginLeft: '20px', marginBottom: '35px', marginTop: '10px' }}>
            <i className="far fa-comments" style={{ color: '#302465', marginRight: '16px'}} />Chats 
          </div>
          <hr />

          {
            loadingChatList ? <Spinner animation="border" variant="warning" className="chat-loading-spinner" /> :
            <div>
              {
                chatList.map((currentChat, i) => {
                  return (
                    <div key={i}
                      className={chat && currentChat._id === chat._id ? "chatUsers active" : "chatUsers"}
                      onClick={() => getChatSession(currentChat.users.filter(user => user !== userId))}
                    >
                      <ChatCard
                        users={currentChat.userInfo}
                        foundations={currentChat.foundationInfo}
                        enterprises={currentChat.enterpriseInfo}
                        myId={userId}
                        messages={currentChat.messages}
                        unreadMessages={currentChat.unreadMessages}
                      />
                    </div>
                  )
                })
              }
            </div>
          }
        </Col>
        <Col xs={9}>
          <div className="userInfoContainer">
            {
              chat ?
              <div>
                {
                  chat.userInfo.filter(user => user._id !== userId).map((user, i) => {
                    return (
                      <div key={i}>
                        <img src={user.logo || defLogo} className="chatUserInfoIcon" alt="Foto de perfil del usuario" />
                        <span className="userInfoName">{user.firstName} {user.lastName}{user.label ? ` - ${user.label}` : ''}</span>
                      </div>
                    )
                  })
                }
              </div> :
              params.get('name') ?
              <span className="userInfoName">Enviar nuevo mensaje a {params.get('name')}</span> : null
            }
          </div>
          <hr />

          {
            !chat ?
            <h3 className="select-chat-message">
              Selecciona un chat
            </h3> :
            loadingChatMessages ? <Spinner animation="border" variant="warning" className="chat-loading-spinner" /> :
            <>
              <div className="messagesContainer" id="messagesList">
                {
                  chat.chatType === 'BENEFIT' ?
                  <Alert variant="info">
                    {
                      chat.benefit.userId === userId ?
                      'En este chat te podrás comunicar con la persona a quien fue asignada la ayuda que publicaste. Escríbele para que puedan coordinar los últimos detalles acerca de esta ayuda (envío, dirección, etc).' :
                      'En este chat te podrás comunicar con la persona que publicó la ayuda que te fue asignada. Escríbele para que puedan coordinar los últimos detalles acerca de esta ayuda (envío, dirección, etc).'
                    }
                  </Alert> :
                  chat.chatType === 'BENEFIT_REQUEST' ?
                  <Alert variant="info">
                    {
                      chat.benefit.userId === userId ?
                      'En este chat te podrás comunicar con la persona que se ofreció a ayudarte con la solicitud que publicaste. Escríbele para que puedan coordinar los últimos detalles acerca de esta ayuda (envío, dirección, etc).' :
                      'En este chat te podrás comunicar con la persona que publicó la solicitud con la cual te ofreciste a ayudar. Escríbele para que puedan coordinar los últimos detalles acerca de esta ayuda (envío, dirección, etc).'
                    }
                  </Alert> :
                  null
                }
                {
                  messages.map((message, i) => {
                    if (message.userId === userId) {
                      return (
                        <div key={i} className="senderMessageElement">
                          <div className="senderMessage">{message.message}</div>
                          <div className="timestamp">
                            { moment(message.timestamp).format('lll') }
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div key={i} className="receiverMessageElement">
                          <div className="receiverMessage">{message.message}</div>
                          <div className="timestamp">
                            { moment(message.timestamp).format('lll') }
                          </div>
                        </div>
                      );
                    }
                  })
                }
              </div>

              <InputGroup className="mb-3 chatInput">
                <FormControl
                  autoComplete="off"
                  type="text"
                  value={currentMessage}
                  onChange={handleMessageChange}
                  onKeyDown={e => e.keyCode === 13 ? handleSendMessage() : null}
                />
                <InputGroup.Append>
                  <Button
                    variant="outline-primary"
                    disabled={currentMessage === ''}
                    onClick={handleSendMessage}
                  >
                    Enviar
                  </Button>
                </InputGroup.Append>
              </InputGroup>
            </>
          }
          
        </Col>
      </Row>
    </Container>
  );
}

const Chat = connect(select, mapDispatchToProps)(ConnectedChat);

export default Chat;
